import './App.css';
import React from "react";

import EasyCalendar from './components/EasyCalendar.js';

function App() {

  return (
    <div className="calendar-container">
      <EasyCalendar  />
    </div>
  );
}

export default App;
